import React, { useContext } from 'react'
import { toast } from 'react-toastify'

import { Button, Dialog } from '@clientbase/clientbase-library'
import { NegativationService } from 'services/NegativationService'

import { toastProps } from 'utils/types/toast-props'

import { NegativationContext } from '../../../context'

export const RecoverDialog: React.FC = () => {
  const {
    dialogRecover,
    updateDialogRecover,
    updateReloadTable,
    updateModalDetail
  } = useContext(NegativationContext)

  const handleClose = (reload?: boolean) => {
    updateDialogRecover({ open: false, uuid: '' })

    if (dialogRecover?.external) {
      if (reload) {
        updateModalDetail((prevState) => ({
          ...prevState,
          reloadKey: Date.now()
        }))
      }
    } else {
      updateModalDetail((prevState) => ({
        ...prevState,
        open: true,
        reloadKey: reload ? Date.now() : prevState?.reloadKey
      }))
    }
  }

  const handleSubmit = async () => {
    const id = toast.loading('Recuperando...')
    const response = await NegativationService.recoverNegativation(
      dialogRecover?.uuid
    )

    if (response?.status === 200) {
      toast.update(id, {
        render: response?.data?.message,
        type: 'success',
        ...toastProps
      })
      updateReloadTable((prevState) => !prevState)
      handleClose(true)
    } else {
      toast.update(id, {
        render: response?.data?.message || 'Erro ao recuperar negativação',
        type: 'error',
        ...toastProps
      })
      handleClose()
    }
  }

  return (
    <Dialog
      title="Marcar como recuperado"
      description="O seu cliente efetuou o pagamento dos débitos pendentes? "
      icon="checkCircle"
      isOpenDialog={dialogRecover?.open}
      setIsOpenDialog={() => handleClose()}
    >
      <Button variantButton="primary" onClick={handleSubmit}>
        Confirmar
      </Button>
    </Dialog>
  )
}
